import {Api} from '../../../Api.js'

const RESOURCE = 'campaign-publication'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    getProgression(id) {

        // Evite l'annulation de la request precedente
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.resource + '/progression/' + id,
            method: 'GET'
        });

        //return Api().get(this.resource + '/progression/' + id)
    },
    cancelProgression(id) {
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.resource + '/cancel/' + id,
            method: 'GET'
        });
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    getStatsByMonth(query) {
        return Api().get(this.resource + '/stats?period=months')
    }
}


// WEBPACK FOOTER //
// ./src/modules/campaign/campaign/CampaignPublicationService.js